import script from "./how-to-getcode-dialog.vue?vue&type=script&setup=true&lang=js"
export * from "./how-to-getcode-dialog.vue?vue&type=script&setup=true&lang=js"

import "./how-to-getcode-dialog.vue?vue&type=style&index=0&id=70adafaa&lang=scss"
import "./how-to-getcode-dialog.vue?vue&type=style&index=1&id=70adafaa&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70adafaa"]])

export default __exports__